export default __webpack_public_path__ + "static/template-team-member-1-3fc63aa4569b8a82febb2c2185c9adf4.jpg";